import { SxProps } from "@mui/material";

export const sxTab: SxProps = {
  textTransform: 'none',
  color: 'var(--primary-blue)',
  flex: 1,
  fontFamily: 'Montserrat-Bold',
  textWrap: 'no-wrap',
  fontSize: 'var(--font-size-small)',
  padding: '8px 24px',
  opacity: 0.6,
  '&.Mui-selected': {
    color: 'var(--primary-blue)',
    opacity: 1
  },
  '@media (max-width: 899px)': {
    '&.Mui-selected': {
      borderBottom: '2px solid var(--primary-blue)'
    }
  }
}

export const sxTabsContainer: SxProps = {
  width: "77%",
  display: "flex",
  alignSelf: "center",
  marginTop: "24px",
  '@media (max-width: 899px)': {
    width: '100%'
  },
  '@media (max-width: 428px)': {
    width: '90%'
  }
}